import * as firebase from 'firebase/app'
import 'firebase/database'

class Message {
  constructor (name, email, subject, messageText) {
    this.name = name
    this.email = email
    this.subject = subject
    this.message = messageText
  }
}

export default {
  state: {
    message: {
      name: '',
      email: '',
      subject: '',
      messageText: ''
    }

  },
  mutations: {
    createMessage (state, payload) {
      state.message = {
        name: payload.name,
        email: payload.email,
        subject: payload.subject,
        messageText: payload.messageText
      }
    }
  },
  actions: {
    async createMessage ({ commit }, payload) {
      commit('clearError')
      const message = new Message(payload.name, payload.email, payload.subject, payload.messageText)
      commit('createMessage', message)
      try {
        commit('setLoading', true)
        await firebase.database().ref('/messages').push(message)
        commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    }
  },
  getters: {
    getMessage (state) {
      return state.message
    }
  }

}
